<template>
  <div :class="['call-to-action', extraClass]">
    <template v-for="(action, _index) in actions" :key="`call-to-action-${_index}`">
      <div class="cta-button">
        <RouterLink v-if="action.type === 'link' && !!action.route" class="cta-button-content" :to="action.route">
          <call-to-action-content :action="action" />
        </RouterLink>
        <a
          v-else-if="action.type === 'link-external' || action.type === 'link-plain'"
          class="cta-button-content"
          :href="action.route"
          :target="getLinkTarget(action.type)"
        >
          <call-to-action-content :action="action" />
        </a>
        <button v-else-if="action.type === 'contact'" class="cta-button-content" @click.prevent="openContactForm()">
          <call-to-action-content :action="action" />
        </button>
        <button
          v-else-if="action.type === 'contact-evaluation'"
          class="cta-button-content"
          @click.prevent="openEvaluationForm()"
        >
          <call-to-action-content :action="action" />
        </button>
        <button
          v-else-if="action.type === 'contact-agency'"
          class="cta-button-content"
          @click.prevent="openAgencyForm()"
        >
          <call-to-action-content :action="action" />
        </button>
        <button
          v-else-if="action.type === 'contact-company-agency'"
          class="cta-button-content"
          @click.prevent="openCompanyAgencyForm()"
        >
          <call-to-action-content :action="action" />
        </button>
        <button
          v-else-if="action.type === 'agent-contact-information'"
          class="cta-button-content"
          @click.prevent="scrollToAgentInformation()"
        >
          <call-to-action-content :action="action" />
        </button>
        <button
          v-else-if="action.type === 'agency-contact-information'"
          class="cta-button-content"
          @click.prevent="scrollToAgencyInformation()"
        >
          <call-to-action-content :action="action" />
        </button>
      </div>
    </template>
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue';
import CallToActionContent from './call-to-action-content.vue';
import type { CtaLinkType } from '@/types/schemaTypes';

export default defineComponent({
  name: 'call-to-action',
  props: {
    actions: {
      type: Array as PropType<CtaLinkType[]>,
      required: true,
    },
    extraClass: {
      type: String,
      required: false,
    },
  },
  methods: {
    getLinkTarget(actionType: string) {
      return actionType === 'link-external' ? '_blank' : '';
    },
    openContactForm() {
      this.$bus.$emit('openDialogue', 'contact-full');
    },
    openEvaluationForm() {
      this.$bus.$emit('openDialogue', 'contact-order-evaluation');
    },
    openAgencyForm() {
      this.$bus.$emit('openDialogue', 'agency-dialogue');
    },
    openCompanyAgencyForm() {
      this.$bus.$emit('openDialogue', 'company-agency-dialogue');
    },
    scrollToAgentInformation() {
      this.$bus.$emit('scrollToAgentInformation');
    },
    scrollToAgencyInformation() {
      this.$bus.$emit('scrollToAgencyInformation');
    },
  },
  components: {
    CallToActionContent,
  },
});
</script>
